import { isProduction } from 'utilities/environmentVariables/environmentVariables';

export const log = {
  debug(...msg: unknown[]) {
    if (!isProduction()) {
      /* eslint-disable no-console */
      console.log('DEBUG: ', ...msg);
    }
  },
  info(...msg: unknown[]) {
    if (!isProduction()) {
      /* eslint-disable no-console */
      console.log('INFO: ', ...msg);
    }
  },

  error(...msg: unknown[]) {
    /* eslint-disable no-console */
    console.log('ERROR: ', ...msg);
  },
};
